"use client";

import {createSystem, defaultConfig, defineTokens} from "@chakra-ui/react";

import {Inter} from "next/font/google";

const inter = Inter({subsets: ["latin-ext"]});

const customTheme = createSystem(defaultConfig, {
  theme: {
    tokens: defineTokens({
      colors: {
        gray: {
          50: {value: "#F7FAFC"},
          100: {value: "#EDF2F7"},
          200: {value: "#E2E8F0"},
          300: {value: "#CBD5E0"},
          400: {value: "#A0AEC0"},
          500: {value: "#718096"},
          600: {value: "#4A5568"},
          700: {value: "#2D3748"},
          800: {value: "#1A202C"},
          900: {value: "#171923"},
        },
      },
      fonts: {
        heading: {
          value: inter.style.fontFamily,
        },
        body: {
          value: inter.style.fontFamily,
        },
      },
      gradients: {
        grayBrand: {
          value: "linear-gradient(180deg, {colors.gray.800}, {colors.gray.900})",
        },
        blueBrand: {
          value:
            "linear-gradient(135deg, {colors.teal.400}, {colors.cyan.600}, {colors.blue.600}, {colors.purple.700})",
        },
        blueBrandMin: {
          value: "linear-gradient(135deg, {colors.teal.400}, {colors.cyan.500}, {colors.blue.400})",
        },
        graph: {
          value:
            "linear-gradient(135deg, {colors.teal.400}, {colors.teal.500}, {colors.green.600}, {colors.green.700})",
        },
        graphMin: {
          value: "linear-gradient(135deg,  {colors.teal.500}, {colors.green.600})",
        },
        showcase: {
          value:
            "linear-gradient(135deg, {colors.purple.400}, {colors.purple.500}, {colors.pink.600}, {colors.pink.700})",
        },
        showcaseMin: {
          value: "linear-gradient(135deg,  {colors.purple.500}, {colors.pink.600})",
        },
        respond: {
          value:
            "linear-gradient(135deg, {colors.orange.400}, {colors.orange.500}, {colors.red.600}, {colors.red.700})",
        },
        respondMin: {
          value: "linear-gradient(135deg,  {colors.orange.500}, {colors.red.600})",
        },
        fireText: {
          value:
            "linear-gradient(170deg, {colors.yellow.400}, {colors.orange.400}, {colors.red.400}, {colors.red.600})",
        },
      },
    }),
  },
});

export default customTheme;
